import { createFileRoute } from "@tanstack/react-router";

import CompetitorSidebar from "@/components/CompetitionEntries/CompetitorSidebar";

const Component = () => {
  const userUuid = Route.useParams().userUuid;
  return <CompetitorSidebar userUuid={userUuid} />;
};

export const Route = createFileRoute(
  "/gym/$venueUuid/events/$competitionUuid/competitors/$userUuid",
)({
  component: Component,
});
